/**
 * Configuración pública del sistema.
 *
 * El nombre de la institución NO se escribe en el código. El ADR-0004 decidió
 * no hardcodearlo para no tener que bifurcar el repositorio si otra escuela
 * quiere usar esto. Vive en la tabla `configuracion` y se sirve por
 * `GET /api/configuracion`.
 *
 * Mientras la respuesta no llegue, la interfaz no muestra un nombre de relleno:
 * escribir "Escuela de Artes" como valor por defecto reintroduciría exactamente
 * el problema que este archivo existe para resolver.
 */

export interface ConfiguracionPublica {
  institucion_nombre: string | null
  zona_horaria: string | null
}

export async function obtenerConfiguracion(): Promise<ConfiguracionPublica> {
  const respuesta = await fetch('/api/configuracion', {
    headers: { accept: 'application/json' },
    signal: AbortSignal.timeout(5000),
  })

  if (!respuesta.ok) {
    throw new Error(`el servidor respondió ${respuesta.status}`)
  }

  const cuerpo: unknown = await respuesta.json()
  if (typeof cuerpo !== 'object' || cuerpo === null) {
    throw new Error('la configuración no vino en el formato esperado')
  }

  const datos = cuerpo as Record<string, unknown>
  const leer = (clave: string): string | null => {
    const valor = datos[clave]
    return typeof valor === 'string' ? valor : null
  }

  return {
    institucion_nombre: leer('institucion_nombre'),
    zona_horaria: leer('zona_horaria'),
  }
}
